export class StuSelectModel {
    id: string;
    items: StuSelectItemModel[];
    selectedItem: StuSelectItemModel;

    constructor(select?) {
        select = select || {};
        this.id = select.id || '';
        this.items = select.items || [];
        this.selectedItem = select.selectedItem || {};
    }
}

export class StuSelectItemModel {
    text: string;
    value: any;

    constructor(select?) {
        select = select || {};
        this.text = select.text;
        this.value = select.value;
    }
}